import React, { useEffect, useState } from "react"
import "./AddInstitution.scss"
import InstituteApi from "Api/InstituteApi"
import * as Yup from "yup"
import { useNavigate } from "react-router-dom"
import UniversityApi from "Api/UniversityApi"
import { Button, Card, CardBody, Col, Row, Spinner } from "reactstrap"
import CustomBreadCrumb from "utils/CustomBreadCrumb/CustomBreadCrumb"
import { InputText } from "primereact/inputtext"
import { InputNumber } from "primereact/inputnumber"
import Country from "../../../utils/Data/Country"
import { Dropdown } from "primereact/dropdown"

import { Calendar } from "primereact/calendar"
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css";

const AddInstitution = () => {
  document.title = "Add Institution"
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate("")
  const accessToken = localStorage.getItem("accessToken")

  const insituteInitialData = {
    institutionName: "",
    university: "",
    category: "",
    displayName: "",
    type: "",
    yearEstablished: "",
    country: "",
    state: "",
    city: "",
    pinCode: null,
    address: "",
    campusSize: "",
    noOfStudents: null,
    noOfDepartments: "",
    noOfCourses: "",
    totalFaculty: "",
    officialWebsite: "",
    nirfRanking: "",
    indiaToday2023Ranking: "",
    timesRanking2024: null,
    email: "",
    ugcApproval: "",
    aiuAffiliation: "",
    highlights: "",
    aboutContent: "",
  }

  const [institutionData, setInstitutionData] = useState(insituteInitialData)

  const handleInstitutionDataChange = (name, value) => {
    setInstitutionData({ ...institutionData, [name]: value })
    setErrors({ ...errors, [name]: "" })
  }

  const [universityData, setUniversityData] = useState([])

  const getUniversityMenu = () => {
    const config = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
    UniversityApi.getUniversityMenuList(config)
      .then(res => {
        setUniversityData(res.data.university)
      })
      .catch(err => {
        console.log(err)
      })
  }

  useEffect(() => {
    getUniversityMenu()
  }, [accessToken])

  const breadcrumbItems = [
    { label: "Home" },
    { label: "Institution" },
    { label: "Add Institution" },
  ]

  const typeOptions = [
    { name: "Private", code: "private" },
    { name: "Government", code: "government" },
    { name: "Autonomous", code: "autonomous" },
  ]
  const categoryOptions = [
    { name: "Medical", code: "medical" },
    { name: "Engineering", code: "engineering" },
    { name: "Arts", code: "arts" },
    { name: "Science", code: "science" },
    { name: "Commerce", code: "commerce" },
    { name: "Law", code: "law" },
    { name: "Management", code: "management" },
    { name: "Architecture", code: "Architecture" },
  ]

  const univerSiytOptions = universityData?.map(university => ({
    name: university.universityName,
    code: university.universityCode,
  }))

  const approvalOptions = [
    { name: "Yes", code: "Yes" },
    { name: "No", code: "No" },
  ]

  const [errors, setErrors] = useState({})

  const ValidateInstitution = Yup.object().shape({
    institutionName: Yup.string().required("Institution name is required"),
    displayName: Yup.string().required("Display name is required"),
    category: Yup.string()
      .oneOf(
        [
          "medical",
          "engineering",
          "arts",
          "science",
          "commerce",
          "law",
          "management",
        ],
        "Invalid category",
      )
      .required("Category is required"),
    type: Yup.string()
      // .oneOf(["private", "government", "autonomous"], "Invalid type")
      .required("Type is required"),
    yearEstablished: Yup.number()
      .typeError("Established year must be a valid number")
      .min(1800, "Year cannot be before 1800")
      .max(new Date().getFullYear(), "Year cannot be in the future")
      .required("Established year is required"),
    country: Yup.string().required("Country is required"),
    university: Yup.string().required("University is required"),
    state: Yup.string().required("State is required"),
    city: Yup.string().required("City is required"),
    pinCode: Yup.string()
      .required("PinCode is required"),
    address: Yup.string().required("Address is required"),
    email: Yup.string()
      .email("Invalid email format")
      .required("Email is required"),
    officialWebsite: Yup.string()
      .required("Website is required"),
    nirfRanking: Yup.string().required("nirfRanking is required"),
    indiaToday2023Ranking: Yup.string().required(
      "indiaToday2023Ranking is required",
    ),
    timesRanking2024: Yup.string().required("timesRanking2024 is required"),
    campusSize: Yup.string().required("campusSize is required"),
    noOfStudents: Yup.string().required("noOfStudents is required"),
    noOfDepartments: Yup.string().required("noOfDepartments is required"),
    noOfCourses: Yup.string().required("noOfCourses is required"),
    totalFaculty: Yup.string().required("totalFaculty is required"),
    ugcApproval: Yup.boolean()
      .oneOf([true, false], "Invalid UGC approval")
      .required("Choose UGC Approval"),
    aiuAffiliation: Yup.boolean()
      .oneOf([true, false], "Invalid AIU Affiliation")
      .required("Choose AIU Affiliation"),
    highlights: Yup.string().required("highlights is required"),
    aboutContent: Yup.string().required("aboutContent is required"),
  })

  const addInstitute = () => {
    const { phoneCode, ...restInstitutionData } = institutionData
    const payload = {
      ...restInstitutionData,
      country: institutionData?.country?.name,
      phone: institutionData?.country?.dialCode + "-" + institutionData?.phone,
      type: institutionData?.type?.name?.toLowerCase(),
      category: institutionData?.category?.name?.toLowerCase(),
      university: institutionData?.university?.code,
      institutionName:
        institutionData?.institutionName?.name ||
        institutionData?.institutionName,
        aiuAffiliation:
        institutionData?.aiuAffiliation?.name === "Yes" ? true : false,
      ugcApproval:
        institutionData?.ugcApproval?.name === "Yes" ? true : false,
    }
    setLoading(true)
    ValidateInstitution.validate(payload, { abortEarly: false })
      .then(() => {
        const config = {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }

        InstituteApi.addInstitution(payload, config)
          .then(res => {
            console.log(res)
            if (res.data.status) {
              setLoading(false)
              setTimeout(() => {
                navigate("/institutionList")

              }, 1000)
              toast.success(res.data.message);


            }
          })
          .catch(err => {
            console.log(err)
            setLoading(false)
            const errorMessage =
              err.res && err.message.data && err.res.data.message
                ? err.res.data.message : "unable to Add Institution";
            toast.error(errorMessage);
          })
      })
      .catch(err => {
        setLoading(false)

        console.log("Validation Errors:", err.inner)
        const validationErrors = {}
        err.inner.forEach(error => {
          validationErrors[error.path] = error.message
        })
        setErrors(validationErrors)
      })
  }
  return (
    <div className="add-institution">
      <ToastContainer />
      <Row>
        <Col xs="12">
          <div className="university-list-header d-flex  align-items-center justify-content-between">
            <CustomBreadCrumb
              data={breadcrumbItems}
              pageTitle="Add Institution"
            />
          </div>

          <Card className="mt-4 ">
            <CardBody>
              <div className="institution-add-form ">
                <div className="institution-add-inp">
                  <label htmlFor="university">University</label>

                  <div className="inp-err">
                    <Dropdown
                      value={institutionData.university}
                      onChange={e => {
                        handleInstitutionDataChange("university", e.value)
                      }}
                      options={univerSiytOptions}
                      optionLabel="name"
                      placeholder="Select University"
                      filter
                    />
                    {errors.university && (
                      <small className="error">{errors.university}</small>
                    )}
                  </div>
                </div>
                <div className="institution-add-inp">
                  <label htmlFor="institutionName">Institution Name</label>
                  <div className="inp-err">
                    <InputText
                      id="institutionName"
                      value={institutionData.institutionName}
                      onChange={e =>
                        handleInstitutionDataChange(
                          "institutionName",
                          e.target.value,
                        )
                      }
                      placeholder="Enter Institution Name"
                    />
                    {errors.institutionName && (
                      <small className="error">{errors.institutionName}</small>
                    )}
                  </div>

                  {/* <Dropdown
            id="institutionName"
            value={institutionData.institutionName}
            onChange={(e) =>
              handleInstitutionDataChange("institutionName", e.value)
            }
            options={institueOptions}
            optionLabel="name"
            placeholder="Select Institution"
            filter
            editable
          /> */}
                </div>
                <div className="institution-add-inp">
                  <label htmlFor="displayName">Display Name</label>

                  <div className="inp-err">
                    <InputText
                      id="displayName"
                      value={institutionData.displayName}
                      onChange={e =>
                        handleInstitutionDataChange(
                          "displayName",
                          e.target.value,
                        )
                      }
                      placeholder="Enter Display Name"
                    />
                    {errors.displayName && (
                      <small className="error">{errors.displayName}</small>
                    )}
                  </div>
                </div>
                <div className="institution-add-inp">
                  <label htmlFor="category">Category</label>
                  <div className="inp-err">
                    <Dropdown
                      value={institutionData.category}
                      onChange={e =>
                        handleInstitutionDataChange("category", e.value)
                      }
                      options={categoryOptions}
                      optionLabel="name"
                      placeholder="Select Category"
                      filter
                    />
                    {errors.category && (
                      <small className="error">{errors.category}</small>
                    )}
                  </div>
                </div>
                <div className="institution-add-inp">
                  <label htmlFor="type">Type</label>

                  <div className="inp-err">
                    <Dropdown
                      value={institutionData.type}
                      onChange={e =>
                        handleInstitutionDataChange("type", e.value)
                      }
                      options={typeOptions}
                      optionLabel="name"
                      placeholder="Select Type"
                      filter
                    />
                    {errors.type && (
                      <small className="error">{errors.type}</small>
                    )}
                  </div>
                </div>
                <div className="institution-add-inp">
                  <label htmlFor="yearEstablished">Year Established </label>

                  <div className="inp-err">
                    <Calendar
                      id="yearEstablished"
                      value={
                        institutionData.yearEstablished
                          ? new Date(institutionData.yearEstablished, 0)
                          : null
                      }
                      onChange={e => {
                        const selectedYear = e.value
                          ? new Date(e.value).getFullYear()
                          : null
                        handleInstitutionDataChange(
                          "yearEstablished",
                          selectedYear,
                        )
                      }}
                      view="year"
                      dateFormat="yy"
                      placeholder="Select Year Established"
                    />

                    {errors.yearEstablished && (
                      <small className="error">{errors.yearEstablished}</small>
                    )}
                  </div>
                </div>

                <div className="institution-add-inp">
                  <label htmlFor="country">Country</label>
                  <div className="inp-err">
                    <Dropdown
                      id="country"
                      value={institutionData.country}
                      onChange={e =>
                        handleInstitutionDataChange("country", e.value)
                      }
                      options={Country}
                      // itemTemplate={countryOptionTemplate}
                      optionLabel="name"
                      placeholder="Select Country"
                      filter
                    />

                    {errors.country && (
                      <small className="error">{errors.country}</small>
                    )}
                  </div>
                </div>

                <div className="institution-add-inp">
                  <label htmlFor="state">State</label>
                  <div className="inp-err">
                    <InputText
                      id="state"
                      value={institutionData.state}
                      onChange={e =>
                        handleInstitutionDataChange("state", e.target.value)
                      }
                      placeholder="Enter State"
                    />
                    {errors.state && (
                      <small className="error">{errors.state}</small>
                    )}
                  </div>
                </div>

                <div className="institution-add-inp">
                  <label htmlFor="username">City</label>
                  <div className="inp-err">
                    <InputText
                      id="city"
                      placeholder="Enter City"
                      value={institutionData.city}
                      onChange={e =>
                        handleInstitutionDataChange("city", e.target.value)
                      }
                    />
                    {errors.city && (
                      <small className="error">{errors.city}</small>
                    )}
                  </div>
                </div>

                <div className="institution-add-inp">
                  <label htmlFor="pinCode">PinCode</label>
                  <div className="inp-err">
                    <InputNumber
                      id="pinCode"
                      value={institutionData.pinCode}
                      onChange={e =>
                        handleInstitutionDataChange("pinCode", e.value)
                      }
                      useGrouping={false}
                      placeholder="Enter PinCode"
                    />
                    {errors.pinCode && (
                      <small className="error">{errors.pinCode}</small>
                    )}
                  </div>
                </div>

                <div className="institution-add-inp">
                  <label htmlFor="address">Address</label>
                  <div className="inp-err">
                    <InputText
                      id="address"
                      value={institutionData.address}
                      onChange={e =>
                        handleInstitutionDataChange("address", e.target.value)
                      }
                      placeholder="Enter Address"
                    />
                    {errors.address && (
                      <small className="error">{errors.address}</small>
                    )}
                  </div>
                </div>
                {/* <div className="institution-add-inp">
                  <label htmlFor="phoneNumber">Phone</label>

                  <div className="inp-err">
                    <div className="p-inputgroup  phone-number ">
                      <Dropdown
                        id="phone"
                        value={institutionData.country}
                        // onChange={e =>
                        //   handleInstitutionDataChange("phoneCode", e.value)
                        // }
                        options={Country}
                        optionLabel="dialCode"
                        placeholder="+XX"
                        filter
                      />
                      <InputNumber
                        id="phoneNumber"
                        value={institutionData.phone}
                        onChange={e =>
                          handleInstitutionDataChange("phone", e.value)
                        }
                        useGrouping={false}
                        placeholder="Enter Phone Number"
                      />
                    </div>
                    {errors.phone && (
                      <small className="error">{errors.phone}</small>
                    )}
                  </div>
                </div> */}
                <div className="institution-add-inp">
                  <label htmlFor="email">Email</label>
                  <div className="inp-err">
                    <InputText
                      id="email"
                      value={institutionData.email}
                      onChange={e =>
                        handleInstitutionDataChange("email", e.target.value)
                      }
                      placeholder="Enter Email"
                    />
                    {errors.email && (
                      <small className="error">{errors.email}</small>
                    )}
                  </div>
                </div>
                <div className="institution-add-inp">
                  <label htmlFor="officialWebsite">Official Website</label>

                  <div className="inp-err">
                    <InputText
                      id="officialWebsite"
                      value={institutionData.officialWebsite}
                      onChange={e =>
                        handleInstitutionDataChange("officialWebsite", e.target.value)
                      }
                      placeholder="Enter Official Website"
                    />
                    {errors.officialWebsite && (
                      <small className="error">{errors.officialWebsite}</small>
                    )}
                  </div>
                </div>
                <div className="institution-add-inp">
                  <label htmlFor="campusSize">Campus Size</label>

                  <div className="inp-err">
                    <InputText
                      id="campusSize"
                      value={institutionData.campusSize}
                      onChange={e =>
                        handleInstitutionDataChange(
                          "campusSize",
                          e.target.value,
                        )
                      }
                      placeholder="Enter CampusSize"
                    />
                    {errors.campusSize && (
                      <small className="error">{errors.campusSize}</small>
                    )}
                  </div>
                </div>
                <div className="institution-add-inp">
                  <label htmlFor="noOfStudents"> No Of Students</label>

                  <div className="inp-err">
                    <InputText
                      id="noOfStudents"
                      value={institutionData.noOfStudents}
                      onChange={e =>
                        handleInstitutionDataChange(
                          "noOfStudents",
                          e.target.value,
                        )
                      }
                      placeholder="Enter No Of Students"
                    />
                    {errors.noOfStudents && (
                      <small className="error">{errors.noOfStudents}</small>
                    )}
                  </div>
                </div>
                <div className="institution-add-inp">
                  <label htmlFor="noOfDepartments"> No Of Departments</label>

                  <div className="inp-err">
                    <InputText
                      id="noOfDepartments"
                      value={institutionData.noOfDepartments}
                      onChange={e =>
                        handleInstitutionDataChange(
                          "noOfDepartments",
                          e.target.value,
                        )
                      }
                      placeholder="Enter No Of Departments"
                    />
                    {errors.noOfDepartments && (
                      <small className="error">{errors.noOfDepartments}</small>
                    )}
                  </div>
                </div>
                <div className="institution-add-inp">
                  <label htmlFor="noOfCourses"> No Of Courses</label>

                  <div className="inp-err">
                    <InputText
                      id="noOfCourses"
                      value={institutionData.noOfCourses}
                      onChange={e =>
                        handleInstitutionDataChange(
                          "noOfCourses",
                          e.target.value,
                        )
                      }
                      placeholder="Enter No Of Courses"
                    />
                    {errors.noOfCourses && (
                      <small className="error">{errors.noOfCourses}</small>
                    )}
                  </div>
                </div>
                <div className="institution-add-inp">
                  <label htmlFor="totalFaculty"> Total Faculty</label>

                  <div className="inp-err">
                    <InputText
                      id="totalFaculty"
                      value={institutionData.totalFaculty}
                      onChange={e =>
                        handleInstitutionDataChange(
                          "totalFaculty",
                          e.target.value,
                        )
                      }
                      placeholder="Enter Total Faculty"
                    />
                    {errors.totalFaculty && (
                      <small className="error">{errors.totalFaculty}</small>
                    )}
                  </div>
                </div>
                <div className="institution-add-inp">
                  <label htmlFor="nirfRanking"> NIRF Ranking</label>

                  <div className="inp-err">
                    <InputText
                      id="nirfRanking"
                      value={institutionData.nirfRanking}
                      onChange={e =>
                        handleInstitutionDataChange(
                          "nirfRanking",
                          e.target.value,
                        )
                      }
                      placeholder="Enter NIRF Ranking"
                    />
                    {errors.nirfRanking && (
                      <small className="error">{errors.nirfRanking}</small>
                    )}
                  </div>
                </div>

                <div className="institution-add-inp">
                  <label htmlFor="indiaToday2023Ranking"> IndiaToday 2023 Ranking</label>

                  <div className="inp-err">
                    <InputText
                      id="indiaToday2023Ranking"
                      value={institutionData.indiaToday2023Ranking}
                      onChange={e =>
                        handleInstitutionDataChange(
                          "indiaToday2023Ranking",
                          e.target.value,
                        )
                      }
                      placeholder="Enter IndiaToday 2023 Ranking"
                    />
                    {errors.indiaToday2023Ranking && (
                      <small className="error">{errors.indiaToday2023Ranking}</small>
                    )}
                  </div>
                </div>

                <div className="institution-add-inp">
                  <label htmlFor="timesRanking2024"> Times Ranking 2024</label>

                  <div className="inp-err">
                    <InputText
                      id="timesRanking2024"
                      value={institutionData.timesRanking2024}
                      onChange={e =>
                        handleInstitutionDataChange(
                          "timesRanking2024",
                          e.target.value,
                        )
                      }
                      placeholder="Enter Times Ranking 2024"
                    />
                    {errors.timesRanking2024 && (
                      <small className="error">{errors.timesRanking2024}</small>
                    )}
                  </div>
                </div>

                <div className="institution-add-inp">
                  <label htmlFor="ugcApproval" className="label">
                    UGC Approval
                  </label>
                  <div className="inp-err ">
                    <Dropdown
                      value={institutionData.ugcApproval}
                      onChange={e =>
                        handleInstitutionDataChange("ugcApproval", e.value)
                      }
                      options={approvalOptions}
                      optionLabel="name"
                      placeholder="Select UGC Affiliation"
                      className="inp-field-box"
                    />
                    {errors.ugcApproval && (
                      <small className="error">{errors.ugcApproval}</small>
                    )}
                  </div>
                </div>
                <div className="institution-add-inp">
                  <label htmlFor="aiuAffiliation" className="label">
                    AIU Affiliation
                  </label>
                  <div className="inp-err">
                    <Dropdown
                      value={institutionData.aiuAffiliation}
                      onChange={e =>
                        handleInstitutionDataChange("aiuAffiliation", e.value)
                      }
                      options={approvalOptions}
                      optionLabel="name"
                      placeholder="Select AIU Affiliation"
                      className="inp-field-box"
                    />
                    {errors.aiuAffiliation && (
                      <small className="error">{errors.aiuAffiliation}</small>
                    )}
                  </div>
                </div>

                <div className="institution-add-inp">
                  <label htmlFor="highlights">Highlights</label>

                  <div className="inp-err">
                    <InputText
                      id="highlights"
                      value={institutionData.highlights}
                      onChange={e =>
                        handleInstitutionDataChange(
                          "highlights",
                          e.target.value,
                        )
                      }
                      placeholder="Enter Highlights"
                    />
                    {errors.highlights && (
                      <small className="error">{errors.highlights}</small>
                    )}
                  </div>
                </div>

                <div className="institution-add-inp">
                  <label htmlFor="aboutContent">About Content</label>

                  <div className="inp-err">
                    <InputText
                      id="aboutContent"
                      value={institutionData.aboutContent}
                      onChange={e =>
                        handleInstitutionDataChange(
                          "aboutContent",
                          e.target.value,
                        )
                      }
                      placeholder="Enter About Content"
                    />
                    {errors.aboutContent && (
                      <small className="error">{errors.aboutContent}</small>
                    )}
                  </div>
                </div>
              </div>
              <div className="save-cancel-btn mt-4 d-flex align-items-center justify-content-end gap-3">
                <Button
                  type="button"
                  outline
                  color="danger"
                  className="waves-effect waves-light"
                  onClick={() => {
                    navigate(-1)
                  }}
                >
                  Cancel
                </Button>
                <Button
                  type="button"
                  color="secondary"
                  className="waves-effect waves-light"
                  onClick={() => {
                    addInstitute()
                  }}
                >
                  {loading ? <Spinner size="sm" /> : "Add"}
                </Button>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  )
}

export default AddInstitution
